import { createAsyncThunk } from '@reduxjs/toolkit';
import { getUsStatesForRegistration, getUsStatesPostLogin } from '../../../service/graphql/misc/getUsStates';
import { AsyncThunkConfig } from '../..';
import { transformUsStates } from './utils';
import { TUsState } from '../types';

export const getUsStatesThunk = createAsyncThunk<TUsState[], { isRegistration?: boolean } | void, AsyncThunkConfig>(
  'misc/getUsStates',
  async (params, { getState, rejectWithValue }) => {
    try {
      const { launchDarkly } = getState();
      // Handle both when params is undefined (no args) and when it's an object with isRegistration property
      const isRegistration = params ? (params as { isRegistration?: boolean }).isRegistration || false : false;

      let response;
      if (isRegistration) {
        response = await getUsStatesForRegistration(launchDarkly.data);
      } else {
        response = await getUsStatesPostLogin(launchDarkly.data);
      }

      const transformedStates = transformUsStates(response.salesforceUSStates);
      return transformedStates;
    } catch (error: any) {
      console.error('Error fetching US states:', error);
      return rejectWithValue(error?.message ?? 'Unknown error occurred');
    }
  },
);
